import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import axios from "axios";
import { var_api } from "../../../constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import { Link } from "react-router-dom";

const WarehouseMaster = () => {
  const tableHeaders = [
    "#",
    "City",
    "Warehouse No",
    "Warehouse ",
    "Full Address",
    "Latitude",
    "Longitude",
    "Status",
    "Action",
  ];

  const [warehouseData, setWarehouseData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [filteredCity, setFilteredCity] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [cityList, setCityList] = useState([]);

  const [formData, setFormData] = useState({
    id: null,
    city_id: "",
    warehouse_no: "",
    warehouse_name: "",
    warehouse_full_address: "",
    warehouse_latitude: "",
    warehouse_longitude: "",
    is_active: 1,
    remarks: "",
  });

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await Promise.all([fetchWarehouseData(), fetchCityData()]);
    } catch {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchWarehouseData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_warehouse_master/get`);
      setWarehouseData(res.data || []);
    } catch {
      toast.error("Failed to fetch warehouse data");
    }
  };

  const fetchCityData = async () => {
  try {
    const res = await axios.get(`${var_api}sa_city_master/get`);
    setCityData(res.data || []);
    setFilteredCity(res.data || []);
    setCityList(res.data || []); // ✅ add this line
  } catch (err) {
    console.error("Failed to fetch city data", err);
  }
};


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const handleAddClick = () => {
    setFormData({
      id: null,
      city_id: "",
        warehouse_no: "",
    warehouse_name: "",
    warehouse_full_address: "",
    warehouse_latitude: "",
    warehouse_longitude: "",
      is_active: 1,
      remarks: "",
    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.city_id) newErrors.city_id = "City is required";
  if (!formData.warehouse_no || !formData.warehouse_no.trim())
  newErrors.warehouse_no = "Warehouse No is required";

if (!formData.warehouse_name || !formData.warehouse_name.trim())
  newErrors.warehouse_name = "Warehouse Name is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(
          `${var_api}sa_veemart_warehouse_master/update/${formData.id}`,
          formData
        );
      } else {
        res = await axios.post(
          `${var_api}sa_veemart_warehouse_master/post`,
          formData
        );
      }
      toast.success(res?.data?.message || "Saved successfully");
      setShowModal(false);
      fetchWarehouseData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = warehouseData.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleCitySearch = (e) => {
    const value = e.target.value;
    setCitySearch(value);
    const filtered = cityData.filter((city) =>
      city.city_name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCity(filtered);
  };

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search warehouse..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>
                  Add
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>
                      {tableHeaders.map((h, i) => (
                        <th key={i}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="10" className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            {
                              cityData.find((c) => c.id === item.city_id)
                                ?.city_name
                            }
                          </td>
                          <td>{item.warehouse_no}</td>
                          <td>{item.warehouse_name}</td>
                          <td>{item.warehouse_full_address}</td>
                          <td>{item.warehouse_latitude}</td>
                          <td>{item.warehouse_longitude}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.is_active === 1
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {item.is_active === 1
                                ? "Active"
                                : "Inactive"}
                            </span>
                          </td>
                          <td className="text-center">
                             <Link to="#" className="btn shadow btn-xs sharp me-1" style={{ backgroundColor: "#007bff", color: "white" }} onClick={() => handleEditClick(item)}>
                                                       <i className="fas fa-pencil-alt"></i>
                                                     </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-end mt-3">
                {[...Array(totalPages)].map((_, idx) => (
                  <Button
                    key={idx}
                    variant={currentPage === idx + 1 ? "primary" : "light"}
                    onClick={() => setCurrentPage(idx + 1)}
                    className="me-1"
                  >
                    {idx + 1}
                  </Button>
                ))}
              </div>
            </>
          )}
        </Card.Body>

        {/* Add/Edit Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Warehouse" : "Add Warehouse"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                {/* City Dropdown */}
<Col md={6}>
  <Form.Group className="mb-2">
    <Form.Label>
      City <span className="text-danger">*</span>
    </Form.Label>
    <Select
      name="city_id"
      value={cityList.find(c => c.id === formData.city_id) || null}
      onChange={(selectedOption) => {
        setFormData({
          ...formData,
          city_id: selectedOption?.id || ''
        });
        setErrors(prev => ({ ...prev, city_id: '' }));
      }}
      options={cityList} // ✅ show all cities — independent of district
      getOptionLabel={(e) => e.city_name}
      getOptionValue={(e) => e.id}
      placeholder="Select City"
      className="narrow-input"
      isClearable
      isSearchable
      isDisabled={false} // ✅ always enabled
    />
    {errors.city_id && (
      <div className="text-danger small mt-1">{errors.city_id}</div>
    )}
  </Form.Group>
</Col>


                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Warehouse No <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="warehouse_no"
                      value={formData.warehouse_no}
                      placeholder="Enter warehouse no"
                      onChange={handleInputChange}
                    />
                    {errors.warehouse_no && (
                      <div className="text-danger small mt-1">{errors.warehouse_no}</div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Warehouse Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="warehouse_name"
                      value={formData.warehouse_name}
                      placeholder="Enter warehouse name"
                      onChange={handleInputChange}
                    />
                    {errors.warehouse_name && (
                      <div className="text-danger small mt-1">{errors.warehouse_name}</div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Full Address</Form.Label>
                    <Form.Control
                      type="text"
                      name="warehouse_full_address"
                      value={formData.warehouse_full_address}
                      placeholder="Enter full address"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Latitude</Form.Label>
                    <Form.Control
                      type="text"
                      name="warehouse_latitude"
                      value={formData.warehouse_latitude}
                      placeholder="Enter latitude"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Longitude</Form.Label>
                    <Form.Control
                      type="text"
                      name="warehouse_longitude"
                      value={formData.warehouse_longitude}
                      placeholder="Enter longitude"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                              {isEditMode && (
                <Col md={6}>
                  <Form.Group className="mb-2 d-flex align-items-center gap-2">
                    <Form.Label className="mb-0">
                      {formData.is_active === 1 || formData.is_active === 'Active' ? "Active" : "Inactive"}
                    </Form.Label>
              
                    <Form.Check
                      type="switch"
                      id="active-status-switch"
                      checked={formData.is_active === 1 || formData.is_active === 'Active'}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          is_active: e.target.checked ? 1 : 0,
                        })
                      }
                      className={
                        formData.is_active === 1 || formData.is_active === 'Active'
                          ? "custom-switch-green"
                          : ""
                      }
                    />
                  </Form.Group>
                </Col>
              )}
              

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                      type="text"
                      name="remarks"
                      value={formData.remarks}
                      placeholder="Enter remarks"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

                <div className="d-flex justify-content-end gap-2 mt-3">
                    {!isEditMode ? (
                      <>
                        <Button variant="secondary" type="submit" disabled={loading}>
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Creating...
                            </>
                          ) : (
                            "Create"
                          )}
                        </Button>
                        <Button
                          variant="danger"
                          type="reset"
                          disabled={loading}
                          onClick={() =>
                            setFormData({
                              id: null,
    city_id: "",
      warehouse_no: "",
    warehouse_name: "",
    warehouse_full_address: "",
    warehouse_latitude: "",
    warehouse_longitude: "",
    is_active: 1,
    remarks: "",
                            })
                          }
                        >
                          Reset
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button variant="warning" type="submit" disabled={loading}>
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Updating...
                            </>
                          ) : (
                            "Update"
                          )}
                        </Button>
                        <Button
                          variant="danger"
                          onClick={() => setShowModal(false)}
                          disabled={loading}
                        >
                          Cancel
                        </Button>
                      </>
                    )}
                  </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>
   <style>{`
  .custom-switch-green .form-check-input:checked {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }
  .custom-switch-red .form-check-input {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
  }
`}</style>
      <ToastContainer />
    </>
  );
};

export default WarehouseMaster;
